/**
 * Polski katalog tekstów do funkcji Książek & Zasad / kampanii
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * Klucze odzwierciedlają wywołania `t('books.*')` w komponentach Reacta funkcji. Wartości
 * to dokładne oryginalne polskie ciągi znaków wydobyte podczas przesiewu i18n.
 */
export const booksPl = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Odbierz Swoje PDF Wspierającego',
  'books.backerModal.sendLinkError': 'Nie mogliśmy wysłać Ci linku do logowania w tej chwili. Spróbuj za chwilę.',
  'books.backerModal.checkInboxPrefix': 'Sprawdź swoją skrzynkę odbiorczą na adresie',
  'books.backerModal.checkInboxSuffix':
    'Jeśli wspierałeś projekt tym adresem e-mail, link do logowania jest w drodze — kliknij go, aby odebrać swoją kopię.',
  'books.backerModal.linkAutoSignIn': 'Link otwiera się na tej stronie i loguje Cię automatycznie. Hasło nie jest potrzebne.',
  'books.backerModal.signInIntro':
    'Wpisz adres e-mail, za pomocą którego wspierałeś projekt. Wyślemy link do logowania jednym kliknięciem, a następnie przygotujemy Twoją osobistą kopię.',
  'books.backerModal.pledgeEmailLabel': 'E-mail konta wspierającego',
  'books.backerModal.emailLinkCta': 'Wyślij mi link do logowania',
  'books.backerModal.prepareTimeout':
    'Przygotowanie Twojej kopii trwa dłużej niż oczekiwano. Spróbuj ponownie za kilka minut.',
  'books.backerModal.notEntitled': 'Jesteś zalogowany, ale Twoja wpłata nie obejmuje tej książki.',
  'books.backerModal.notClaimable': 'Ta książka nie jest oferowana jako pobieranie dla wspierających.',
  'books.backerModal.prepareError': 'Nie mogliśmy przygotować Twojego pobrania w tej chwili. Spróbuj za chwilę.',
  'books.backerModal.signedInAs': 'Zalogowany jako',
  'books.backerModal.signOut': 'Wyloguj się',
  'books.backerModal.verified': 'Zweryfikowany',
  'books.backerModal.welcomeBack': ' — witaj z powrotem,',
  'books.backerModal.backerNumber': '(Wspierający nr {number})',
  'books.backerModal.copyReady':
    'Twoja osobista kopia jest gotowa. Ten link jest osobisty i wkrótce wygaśnie — prosimy go nie udostępniać.',
  'books.backerModal.downloadPdf': 'Pobierz swoje PDF',
  'books.backerModal.dtrpgEmailLabel': 'E-mail konta DriveThruRPG',
  'books.backerModal.optional': '(opcjonalnie)',
  'books.backerModal.dtrpgWarn':
    'Dodaj to, aby również mirrować zakup do biblioteki DriveThruRPG. Pomiń to, a Twoja kopia pozostanie dostępna tutaj.',
  'books.backerModal.preparingCopy': 'Przygotowywanie Twojej kopii…',
  'books.backerModal.prepareDownload': 'Przygotuj i Pobierz',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Ten link do logowania nie posiada tokenu. Poproś o nowy link ze strony książki.',
  'books.backerVerify.invalidToken':
    'Ten link do logowania jest nieprawidłowy lub wygasł. Poproś o nowy ze strony książki.',
  'books.backerVerify.seoTitle': 'Logowanie wspierającego',
  'books.backerVerify.seoDescription': 'Weryfikowanie linku do logowania wspierającego Grymwyrd.',
  'books.backerVerify.confirming': 'Potwierdzanie logowania wspierającego…',
  'books.backerVerify.signedInHeading': 'Jesteś zalogowany',
  'books.backerVerify.signedInAs': 'Zalogowany jako',
  'books.backerVerify.headBackPrefix': 'Wróć do książki i kliknij',
  'books.backerVerify.downloadWord': 'Pobierz',
  'books.backerVerify.headBackSuffix': 'aby odebrać swoją kopię.',
  'books.backerVerify.backToBook': 'Powrót do Twojej książki',
  'books.backerVerify.browseAthenaeum': 'Przeglądaj Atheneum',
  'books.backerVerify.problemHeading': 'Problem z linkiem do logowania',

  // BookCard.tsx
  'books.card.viewAria': 'Wyświetl {title}',
  'books.card.coverAlt': 'Okładka {title}',
  'books.card.owned': 'Posiadana',

  // BookCover.tsx
  'books.cover.coverAlt': 'Okładka {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Książki i Zasady',
  'books.store.seoDescription':
    'Tomy wiecznego zmroku — podręczniki podstawowe, ilustrowany SRD i mroczne przygody. Kup, aby odblokować moduły i zdobyć monety.',
  'books.store.eyebrow': 'Atheneum',
  'books.store.heading': 'Książki i Zasady',
  'books.store.intro':
    'Zdobądź tomy, które łączą świat. Każdy zakup odblokowuje grywalnych modułów w Twoich kampaniach i nagradza Cię monetami dla gospodarki wewnątrzświatowej.',
  'books.store.filterAria': 'Filtruj książki wg typu',
  'books.store.filterAll': 'Wszystkie',
  'books.store.loading': 'Otwieranie archiwum…',
  'books.store.empty': 'Żadne tomy nie pasują do tej kategorii. Kopidłami wciąż pracują.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'Kasa nie jest jeszcze dostępna. Spróbuj ponownie wkrótce.',
  'books.buy.signInToClaim': 'Zaloguj się, aby odebrać ten tom.',
  'books.buy.ledgerSealed': 'Księga handlowca jest zamknięta na razie — kasa wkrótce się pojawi.',
  'books.buy.inLibrary': 'W Twojej Bibliotece',
  'books.buy.openingVault': 'Otwieranie skarbca…',
  'books.buy.claimFree': 'Odbierz Bezpłatnie',
  'books.buy.buyPrice': 'Kup — {price}',
  'books.buy.unlockPrefix': 'Kup → odblokuj moduły +',
  'books.buy.coinsSuffix': '{coins} monet',

  // BookDetailPage.tsx
  'books.detail.loading': 'Przewracanie stron…',
  'books.detail.backToAthenaeum': 'Powrót do Atheneum',
  'books.detail.unlockOwned': 'Posiadasz ten tom — jego lokalna Grymwyrd jest odblokowana w całej encyklopedii.',
  'books.detail.unlockClaim': 'Odbierz ten tom, aby odblokować jego lokal Grymwyrd w całej encyklopedii.',
  'books.detail.returnTo': 'Powrót do {label}',
  'books.detail.backerCta': 'Wspierasz projekt? Pobierz swoje PDF',
  'books.detail.coinsEarned': 'Zarobiłeś {coins} monet z tego zakupu.',
  'books.detail.coinsGranted': 'Zakup przyznaje {coins} monet Twojemu skarbowi.',
  'books.detail.byAuthor': 'Autor: {author}',
  'books.detail.statPrice': 'Cena',
  'books.detail.statPages': 'Strony (ostatnie renderowanie)',
  'books.detail.statWords': 'Słowa (ostatnie renderowanie)',
  'books.detail.ofThisTome': 'O Tym Tomie',
  'books.detail.noDescription': 'Żaden opis nie został jeszcze wpisany dla tego tomu.',
  'books.detail.previewHeading': 'Podgląd',
  'books.detail.previewBlurb': 'Rzuć okiem na próbkę tego tomu, zanim go odbierzesz.',
  'books.detail.readPreview': 'Przeczytaj podgląd',
  'books.detail.tocHeading': 'Spis Treści',
  'books.detail.tocEmpty': 'Treść tego tomu nie została jeszcze skalogowana.',
  'books.detail.pageAbbrev': 's. {page}',
  'books.detail.unlockedHeading': 'Odblokowane Wpisy Encyklopedii',
  'books.detail.unlockedOwnedNote': 'Teraz część Twojej żywej encyklopedii:',
  'books.detail.unlockedLockedNote':
    'Kup ten tom, aby wpisać jego bestie, zaklęcia i sekrety do encyklopedii — i odebrać',
  'books.detail.coinsAmount': '{coins} monet',
  'books.detail.attributionsHeading': 'Przypisania i Licencjonowanie',
  'books.detail.attributionSource': 'Źródło',
  'books.detail.attributionLink': 'link',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Aktywna Kampania',
  'books.campaign.backThisProject': 'Wspieraj Ten Projekt',
  'books.campaign.viewStretchGoals': 'Wyświetl Cele Dodatkowe',
  'books.campaign.pledged': 'Wpłacono',
  'books.campaign.backers': 'Wspierający',
  'books.campaign.pitchHeading': 'Zaczyn',
  'books.campaign.backerUnlockedHeading': 'Wpisy Odblokowane przez Wspierających',
  'books.campaign.backerUnlockedBlurb':
    'Wspierający uzyskują wczesny dostęp do treści, które trafiają prosto do żywej encyklopedii. Oto smak już obowiązującego kanonu:',
  'books.campaign.previewsEmpty': 'Nowy kanon jest wpisywany — wracaj, gdy cele się odemkną.',
  'books.campaign.choosePledge': 'Wybierz Swoją Wpłatę',
  'books.campaign.mostBacked': 'Najczęściej Wspierane',
  'books.campaign.pledgeAmount': 'Wpłacaj {amount}',
  'books.campaign.pledgeFooter':
    'Wpłaty są przetwarzane bezpiecznie w kasie. Nagrody za wspieranie (monety, moduły i odblokowania encyklopedii) są przyznawane Twojemu kontu Grymwyrd, gdy usługa kampanii przejdzie online.',

  // LanguageSelect.tsx
  'books.language.label': 'Język',

  // PreviewModal.tsx
  'books.preview.title': 'Podgląd — {title}',
  'books.preview.pdfAria': 'Podgląd PDF {title}',
  'books.preview.cannotDisplay': 'Twój czasomierz nie może wyświetlić podglądu w linii.',
  'books.preview.openNewTab': 'Otwórz podgląd w nowej karcie',
  'books.preview.preparingHeading': 'Podgląd jest przygotowywany.',
  'books.preview.preparingBody':
    'Próbka tego tomu jest wpisywana przez skryptorium i wkrótce się tutaj pojawi. W międzyczasie, rzuć okiem na to, co czeka:',
  'books.preview.excerptLabel': 'Urywek — {title}',
  'books.preview.excerptFallback':
    'Poza tą bramą leżą strony przesączone lękiem i cudem. Zdobądź tom, aby czytać dalej.',
  'books.preview.noExcerpt': 'Żaden urywek nie został skalogowany dla tego tomu.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Zaklęcia',
  'books.rules.sectionMonsters': 'Bestie',
  'books.rules.sectionMagicItems': 'Przedmioty Magiczne',
  'books.rules.sectionWeapons': 'Bronie',
  'books.rules.sectionArmor': 'Zbroja',
  'books.rules.sectionSkills': 'Umiejętności',
  'books.rules.entriesCount': '{entries} wpisów',
  'books.rules.readingLabel': 'Czytanie {label}…',
  'books.rules.noneCatalogued': 'Brak {label} skalogowanych w tym systemie.',
  'books.rules.browseAll': 'Przeglądaj wszystkie {label} w encyklopedii →',
  'books.rules.seoTitle': 'Zasady i SRD',
  'books.rules.seoDescription':
    'Przeglądaj System Reference Document — zaklęcia, bestie, przedmioty i zasady, które łączą wieczny zmrok. 5e SRD teraz, z więcej systemami na horyzoncie.',
  'books.rules.eyebrow': 'Kodeks',
  'books.rules.heading': 'Zasady i Dokument Referencyjny',
  'books.rules.intro':
    'Otwarta treść gry, która napędza Grymwyrd. Przeglądaj wpisy istotne dla zasad i zanurz się w pełnej encyklopedii dla bloków statystyk i lokali. Grymwyrd dostarcza 5e SRD teraz — PF2e i inne systemy idą.',
  'books.rules.loading': 'Konsultowanie kodeksu…',
  'books.rules.gameSystems': 'Systemy Gry',
  'books.rules.noSystems': 'Żadne systemy gry nie są jeszcze zarejestrowane.',
  'books.rules.openSrd': 'Otwórz SRD',
  'books.rules.lockedComingSoon': 'Zablokowany — wkrótce',
  'books.rules.referenceContent': '{name} — Treść Referencyjna',
  'books.rules.releasedUnder': 'Wydane na warunkach {license}',
  'books.rules.licenseLink': 'licencja',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Postęp finansowania {title}',
  'books.stretch.unlockedAdded': 'Odblokowany — dodany do encyklopedii',
  'books.stretch.percentFunded': '{pct}% sfinansowany',
  'books.stretch.autoPopulates': 'Automatycznie wypełnia encyklopedię',
  'books.stretch.raisedSoFar': 'Zebrano dotychczas',
  'books.stretch.backers': 'Wspierający',
  'books.stretch.overallAria': 'Całkowite finansowanie kampanii',
  'books.stretch.heading': 'Cele Dodatkowe',
} as const
